import { Observable } from 'rxjs';
import { BaseLayerItemService } from '../services/base-layer-item.service';
import { LayerItemV2 } from './layer-item';
import { NativeLayer } from './native-layer';

export class MapTooltipParams {
  nativeLayer: NativeLayer;
  layerItem: LayerItemV2;
  allLayerItems: LayerItemV2[];
  layerItemsChange$: Observable<LayerItemV2[]>;
  layerItemService: BaseLayerItemService;
}
